import { navigationItems } from "../config/navigation";

export const PUBLISHER_AGREEMENT_ROUTE = "/privacy-policies";
export const PUBLISH_YOUR_APP_ROUTE = "/publish-your-app";

export const PUBLISH_FORM_DRAFT_STORAGE_KEY = "oac:publish-form-draft";

export type PublishFormDraft = {
  appName: string;
  categoryId: string;
  problemSolved: string;
  shortDescription: string;
  version: string;
  developerWebsite: string;
  appForSale: boolean;
  publisherAgreement: boolean;
};

export type PublisherAgreementReturnState = {
  publisherAgreementAccepted?: boolean;
};

export function buildAgreementAcceptReturnState(): PublisherAgreementReturnState {
  return { publisherAgreementAccepted: true };
}

export function shouldCheckAgreementOnReturn(state: unknown): boolean {
  return (
    typeof state === "object" &&
    state !== null &&
    (state as PublisherAgreementReturnState).publisherAgreementAccepted === true
  );
}

export function applyAgreementAcceptanceToDraft(
  draft: PublishFormDraft,
): PublishFormDraft {
  return { ...draft, publisherAgreement: true };
}

export function mergeDraftWithReturnState(
  draft: PublishFormDraft | null,
  fallback: PublishFormDraft,
  accepted: boolean,
): PublishFormDraft {
  const base = draft ?? fallback;
  return accepted ? applyAgreementAcceptanceToDraft(base) : base;
}

export function getPublisherAgreementNavItem() {
  return navigationItems.find((item) => item.path === PUBLISHER_AGREEMENT_ROUTE);
}

export function savePublishFormDraft(
  draft: PublishFormDraft,
  storage: Pick<Storage, "setItem"> = sessionStorage,
): void {
  storage.setItem(PUBLISH_FORM_DRAFT_STORAGE_KEY, JSON.stringify(draft));
}

export function loadPublishFormDraft(
  storage: Pick<Storage, "getItem"> = sessionStorage,
): PublishFormDraft | null {
  const raw = storage.getItem(PUBLISH_FORM_DRAFT_STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw) as PublishFormDraft;
    if (
      typeof parsed.appName !== "string" ||
      typeof parsed.categoryId !== "string" ||
      typeof parsed.problemSolved !== "string" ||
      typeof parsed.shortDescription !== "string" ||
      typeof parsed.version !== "string" ||
      typeof parsed.developerWebsite !== "string" ||
      typeof parsed.appForSale !== "boolean" ||
      typeof parsed.publisherAgreement !== "boolean"
    ) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function clearPublishFormDraft(
  storage: Pick<Storage, "removeItem"> = sessionStorage,
): void {
  storage.removeItem(PUBLISH_FORM_DRAFT_STORAGE_KEY);
}
